import script from "./BasicLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicLayout.vue?vue&type=script&setup=true&lang=js"

import "./BasicLayout.vue?vue&type=style&index=0&id=34eb2568&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34eb2568"]])

export default __exports__